Barba.Prefetch.init();

let Homepage = Barba.BaseView.extend({
    namespace: 'homepage',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
    },
    onEnterCompleted: function() {
        // The Transition has just finished.

    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

// Don't forget to init the view!
Homepage.init();

Barba.Pjax.start();
Barba.Pjax.cacheEnabled = false;


let HideShowTransition = Barba.BaseTransition.extend({
    start: function() {
        this.newContainerLoading.then(this.finish.bind(this));
    },

    finish: function() {
        document.body.scrollTop = 0;
        this.done();
    }
});


let FadeTransition = Barba.BaseTransition.extend({
    start: function() {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page

        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));

    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */


        $('.footer').animate({opacity: 0});

        return $(this.oldContainer).animate({ opacity: 0 }).promise();


    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        var _this = this;
        var $el = $(this.newContainer);

        $(window).scrollTop(0);

        $(this.oldContainer).hide();
        page.unload();

        $('.header-nav').removeClass('alt');

        $el.css({
            visibility : 'invisible',
            opacity : 0
        });


        $('html').animate({
            scrollTop:0
        }, 200, 'swing', function() {

            page.main.f.changeMenuClass($el.data('namespace'));

            $('.burger.toggle-menu').removeClass('scrolled');

            if($el.data('parent') != 0){
                $('.header-main-nav').find('.ajax-barb').removeClass('active');
                $('.mobile-nav-main').find('li').removeClass('active');
                $('.menu-page-'+$el.data('parent')).addClass('active');

            }else{

                $('.header-main-nav').find('.stagger a').removeClass('active');
                $('.mobile-nav-main').find('li').removeClass('active');
                $('.menu-page-'+$el.data('id')).addClass('active');

            }
            _this.done();
            $('.footer').animate({opacity:1})
            setTimeout(function(){
                //_this.done();

                if(page.main.fr.magicScroll.controller !== null) {
                    page.main.fr.magicScroll.reset();
                }
                page.ajaxLoaded(1, function(){

                    if(displayCarrier && $el.data('namespace') !== 'contacts'){
                        $('.sticky-career').addClass('active');
                    }else{
                        $('.sticky-career').removeClass('active');
                    }
                    TweenMax.to($el, 2.5 , { autoAlpha: 1, onComplete: function(){}});

                });

            },500);

        });

    }

});



Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
Barba.Pjax.preventCheck = function(evt, element) {




    if($(element).hasClass('ajax-barb') && $(element).hasClass('scrollTop')){
        return false;
    }

    if($(element).hasClass('ajax-barb')){
        return true;
    }
    if(element === null){
        return false;
    }

    if (element) {
        /**
         * You Can Add Your Custom Check Here
         */
        if (!$(element).hasClass('ajax-barb')) {

            return false;
        }

        if (!Barba.Pjax.originalPreventCheck(evt, element)) {
            return false;
        }
    }

    return true;

};



Barba.Pjax.getTransition = function() {
    return FadeTransition;
};

Barba.Dispatcher.on('initStateChange', function(currentStatus, oldStatus, container) {

});